import Vue from "vue";
import Vuex from "vuex";

import axios from "axios";
import { jwtDecode } from "jwt-decode";

import nodered from "@/store/modules/nodered.js";
import utils from "@/store/modules/utils.js";

Vue.use(Vuex);

const BASE =
  process.env.VUE_APP_LOCAL == "1"
    ? process.env.VUE_APP_LOCAL_BASE_URL
    : `${window.location.protocol}//${window.location.hostname}`;

console.log("BASE", BASE);
console.log("VUE_APP_LOCAL", process.env.VUE_APP_LOCAL);

const PORT =
  process.env.VUE_APP_LOCAL == "1"
    ? process.env.VUE_APP_LOCAL_PORT
    : window.location.protocol.includes("https")
    ? "443"
    : `${process.env.VUE_APP_BACKEND_PORT}`;

console.log("PORT", PORT);

export default new Vuex.Store({
  state: {
    base_url: `${BASE}:${PORT}/api`,
    token: "",
    user: {},

    pages: [],
    selectedPage: 0,
    selectedItem: null,
    selectedItemIndex: 0,
    editing: false,
    showLeftMenu: true,

    scadaDimensions: {
      width: 0,
      height: 0,
    },

    copyedElement: null
  },

  getters: {
    activePages(state) {
      return state.pages.filter((page) => page.active);
    },

    actualPage(state) {
      return state.pages[state.selectedPage];
    },

    userRole(state) {
      return state.user.role_name;
    },

    isLaboratory(state) {
      return state.user.role_name == "laboratory";
    },

    isAdmin(state) {
      return state.user.is_admin;
    },
    scadaWidth: (state) => state.scadaDimensions.width,
    scadaHeight: (state) => state.scadaDimensions.height,
  },

  mutations: {
    setDimensions(state, dimensions) {
      console.log("las nuevas dimensiones en store", dimensions);
      state.scadaDimensions.width = dimensions.width;
      state.scadaDimensions.height = dimensions.height;
    },

    setUser(state, payload) {
      state.token = payload;
      state.user = payload ? jwtDecode(payload) : {};
    },

    setEditing(state, value) {
      state.editing = typeof value == "boolean" ? value : !state.editing;
    },

    selectItem(state, { index, item }) {
      state.selectedItemIndex = index;
      state.selectedItem = item.settings.show_in_exec
        ? state.pages[state.selectedPage].item_list[index]
        : state.pages[state.selectedPage].global_item_list[index];
    },

    updateSelectedItem(state, payload) {
      if (state.selectedItem) {
        Object.assign(state.selectedItem, payload);

        if (state.selectedItem.settings.show_in_exec) {
          if (state.selectedItemIndex !== -1)
            Vue.set(state.pages[state.selectedPage].item_list, state.selectedItemIndex, state.selectedItem);
        } else {
          if (state.selectedItemIndex !== -1)
            Vue.set(state.pages[state.selectedPage].global_item_list, state.selectedItemIndex, state.selectedItem);
        }
      }
    },

    deselectItem(state) {
      state.selectedItem = null;
    },

    addItem(state, item) {
      item.settings.show_in_exec
        ? state.pages[state.selectedPage].item_list.push(item)
        : state.pages[state.selectedPage].global_item_list.push(item);
      state.selectedItem = item;
    },

    updateItem(_, { item, pos }) {
      item.customized.width = pos.width;
      item.customized.height = pos.height;
      item.customized.left = pos.left;
      item.customized.top = pos.top;
    },

    toggleLeftMenu(state, value) {
      state.showLeftMenu = value != undefined ? value : !state.showLeftMenu;
    },

    loadPages(state, payload) {
      state.pages = payload;
      console.group("las paginas");
      console.log(state.pages);
      console.groupEnd();
    },

    setSelectedPage(state, payload) {
      state.selectedPage = payload;
      state.selectedItem = null;
    },

    addPage(state, payload) {
      state.pages.push(payload);
      this.commit("setSelectedPage", state.pages.filter((page) => page.active).length - 1);
    },

    deletePage(state) {
      const indexToChange =
        state.pages
          .filter((page) => page.active)
          .map((e) => e.name)
          .indexOf(state.pages[state.selectedPage].name) - 1 || state.pages.length - 1;
      state.pages[state.selectedPage].active = false;
      this.commit("setSelectedPage", indexToChange);
      return indexToChange;
    },

    changePageName(state, payload) {
      const pagesNames = state.pages.map((page) => (page.active ? page.name : ""));
      if (!pagesNames.includes(payload)) {
        state.pages[state.selectedPage].name = payload;
      } else {
        alert("Existe una página con ese nombre");
      }
    },

    putBackground(state, payload) {
      state.pages[state.selectedPage].background_image = payload;
    },
    copySelectedElement(state){
      state.copyedElement = state.selectedItem;
      console.log("Copiando", state.copyedElement)
    },
    
  },

  actions: {
    // updateDimensions({ commit }, dimensions) {
    updateDimensionsInStore({ commit }, dimensions) {
      console.log("dimensions", dimensions);
      commit("setDimensions", dimensions);
    },

    // Actions for API
    async getData({ state }, { path, params }) {
      const response = await axios.get(`${state.base_url}/${path}`, {
        headers: { authorization: `Bearer ${state.token}` },
        params,
      });
      return response.data;
    },

    async postData({ state }, { path, body }) {
      const response = await axios.post(`${state.base_url}/${path}`, body, {
        headers: { authorization: `Bearer ${state.token}` },
      });
      return response.data.success;
    },

    async postDataWithReturn({ state }, { path, body }) {
      const response = await axios.post(`${state.base_url}/${path}`, body, {
        headers: { authorization: `Bearer ${state.token}` },
      });
      return response.data;
    },

    async putData({ state }, { path, params, body }) {
      const response = await axios.put(`${state.base_url}/${path}${params ? `/${params}` : ""}`, body, {
        headers: { authorization: `Bearer ${state.token}` },
      });
      return response.data.success;
    },

    // Actions for token management
    storeUser({ commit }, payload) {
      localStorage.setItem("token", payload);
      commit("setUser", payload);
    },

    retrieveToken({ commit }) {
      const token = localStorage.getItem("token");
      commit("setUser", token);
    },

    logout({ commit }) {
      commit("setUser", "");
      localStorage.removeItem("token");
    },

    updateEditing({ commit }, value) {
      commit("setEditing", value);
    },

    selectItem({ commit }, payload) {
      commit("selectItem", payload);
    },

    updateSelectedItem({ commit }, payload) {
      commit("updateSelectedItem", payload);
    },

    deselectItem({ commit }, payload) {
      commit("deselectItem", payload);
    },

    addItem({ commit }, payload) {
      const item = JSON.parse(JSON.stringify(payload));
      commit("addItem", item);
    },

    updateItem({ commit }, { item, rect }) {
      const pos = {
        width: rect.width,
        left: rect.left,
        height: rect.height,
        top: rect.top,
      };
      commit("updateItem", { item, pos });
    },

    changeShowLeftMenu({ commit }) {
      commit("toggleLeftMenu");
    },

    async loadPages({ commit }) {
      const pages = await this.dispatch("getData", { path: "pages" });
      commit("loadPages", pages);
    },

    addPage({ commit }, payload) {
      commit("addPage", payload);
    },

    setSelectedPage({ commit }, payload) {
      commit("setSelectedPage", payload);
    },

    setSelectedPageToHome({ state, commit }) {
      const activePage = state?.pages?.findIndex((e) => e.main == true && e.active == true);
      commit("setSelectedPage", activePage > 0 ? activePage : 0);
    },

    deletePage({ commit }) {
      commit("deletePage");
    },

    changePageName({ commit }, payload) {
      commit("changePageName", payload);
    },

    putBackground({ commit }, payload) {
      commit("putBackground", payload);
    },
    copySelectedElement({commit}){
      commit("copySelectedElement");
    },

    
    pasteSelectedElement({commit, dispatch, state}){
      dispatch('addItem',state.copyedElement);
    }
  },

  modules: { nodered, utils },
});
